import styled from "styled-components";

const InnerLayoutStyle = styled.div`
  background-color: brown;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

export default InnerLayoutStyle;
